import { render } from "./BrandBolha.vue?vue&type=template&id=69f94004"
import script from "./BrandBolha.vue?vue&type=script&lang=ts"
export * from "./BrandBolha.vue?vue&type=script&lang=ts"

import "./BrandBolha.vue?vue&type=style&index=0&id=69f94004&lang=scss"
script.render = render

export default script